import { render, staticRenderFns } from "./_ManifestDetail.vue?vue&type=template&id=584b45c2&scoped=true&"
import script from "./_ManifestDetail.vue?vue&type=script&lang=js&"
export * from "./_ManifestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b45c2",
  null
  
)

export default component.exports